import { ConsignmentDetails } from 'types';
import { Accordion } from 'components';
import { CollectForm, CollectRegistration } from './components';

interface Props {
  consignment: ConsignmentDetails;
  defaultOpen?: boolean;
}

export function Collect({ consignment, defaultOpen = false }: Props) {
  const { lastRegistration } = consignment;
  const isCollected = Boolean(lastRegistration.carrier);

  return (
    <Accordion title="Registro da Retirada" defaultOpen={defaultOpen}>
      {!isCollected ? (
        <CollectForm consignmentDetails={consignment} />
      ) : (
        <CollectRegistration consignmentDetails={consignment} />
      )}
    </Accordion>
  );
}
